import React, { useState } from "react";
import { CartContext } from "../../context/CartContext";
import { NavLink, useParams } from "react-router-dom";
import CartItemsSummary from "./CartItemsSummary";
import CartCustomerDetails from "./CartCustomerDetails";
import { BASKET_TYPE_CHOICES, ADDR_TYPE_CHOICES, SYSTEM_CHOICES } from "../../components/Enumerators";
import CartClass from "../../classes/CartClass";
import { IOrder } from "../../interfaces/IOrder";
import CartPayment from "./CartPayment";
import { ICartProduct } from "../../interfaces/ICartProduct";
import { CartStepBar } from "./CartStepBar";
import { IUrlCart } from "../../interfaces/IUrl";
// import { ICartProduct } from '../../interfaces/ICartProduct';
export interface ICart {
    system?: SYSTEM_CHOICES; // np. BB - Bieg Belfra
}

const Cart = (props: ICart) => {
    // const [basketId] = useState(CartClass.get_basketId(BASKET_TYPE_CHOICES.BASKET_ORDER));
    const [isUserInfoRead, setIsUserInfoRead] = useState(false);
    const urlParams = useParams<IUrlCart>();
    const [basketId] = useState(
        urlParams.basketId
            ? () => {
                  CartClass.set_basketId(BASKET_TYPE_CHOICES.BASKET_ORDER, urlParams.basketId);
                  return urlParams.basketId;
              }
            : CartClass.get_basketId(BASKET_TYPE_CHOICES.BASKET_ORDER)
    );

    // wszystkie dane związane z zamówieniem -> inicjalizuję wartości domyślne
    const [order, setOrder] = useState<IOrder>({
        products: [] as ICartProduct[],
        addrContact: { addrType: ADDR_TYPE_CHOICES.ADDR_TYPE_CONTACT_BY_USER, aName: "" },
        addrPayer: { addrType: ADDR_TYPE_CHOICES.ADDR_TYPE_PAYER_BY_USER, aName: "" },
        addrRecipient: { addrType: ADDR_TYPE_CHOICES.ADDR_TYPE_RECIPIENT_BY_USER, aName: "" },
        addrShipment: { addrType: ADDR_TYPE_CHOICES.ADDR_TYPE_SHIPMENT_BY_USER, aName: "" },
        // addr: [
        //   {
        //     type:ADDR_TYPE_CHOICES.ADDR_TYPE_PAYER_BY_USER
        //   },
        //   {
        //     type:ADDR_TYPE_CHOICES.ADDR_TYPE_RECIPIENT_BY_USER
        //   },
        //   {
        //     type:ADDR_TYPE_CHOICES.ADDR_TYPE_SHIPMENT_BY_USER
        //   },
        // ],
        //addr: [] as IAddr[],
        summary: 0,
        invoice: false,
        recipent: true,
    });

    // useEffect(() => {

    //     console.log("Zmiana order: cart.tsx")

    // }, [order])

    // console.log("_________________________")
    // console.log(order)

    /* Wyświetl informacje o błędzie API*/
    const [notification, setNotification] = useState<String | undefined | JSX.Element>();

    const [activeStepId, setActiveStepId] = useState(1);

    //===============================================
    //output
    // if (isLoaded) {
    //     return (<div>Ładowanie...
    //             {notification}</div>
    //     )
    //   } else {

    return (
        <section>
            <div className="container px-5 mt-5">
                {/* <div > */}
                <div>
                    <h1 className="is-size-4-mobile is-size-3 has-text-weight-bold">Twoje zamówienie</h1>
                    <NavLink to={"/"}>
                        <i className="fas fa-chevron-left mr-3"></i> Wróć do sklepu
                    </NavLink>

                    {notification}

                    <CartStepBar activeStepId={activeStepId} />

                    <CartContext.Provider value={{ setActiveStepId, basketId, order, setOrder, isUserInfoRead, setIsUserInfoRead, setNotification }}>
                        {activeStepId === 1 && (
                            <>
                                <CartItemsSummary />
                            </>
                        )}
                        {activeStepId === 2 && (
                            <>
                                <CartCustomerDetails />
                            </>
                        )}

                        {activeStepId === 3 && (
                            <>
                                <CartPayment />
                            </>
                        )}
                    </CartContext.Provider>

                    <p className="webinar-adnotation webinar-muted has-text-centered mt-6">
                        W razie pytań,{" "}
                        <NavLink key="contact-us" to={"/kontakt"}>
                            {" "}
                            skontaktuj się z nami.
                        </NavLink>
                    </p>

                    {/* </>
                  }
                  {products.length === 0 && <Notification lead="" type="info" msg="Nie masz żadnych produktów w koszyku."></Notification> } */}
                </div>
                {/* </div> */}
            </div>
        </section>
    );
};

// }

export default Cart;
